// 正式
module.exports = {
  title: 'produce',
  // baseUrl: 'http://47.110.87.64/api', // 正式项目地址
  // baseApi: 'http://47.110.87.64/api', // 正式api请求地址
  baseUrl: 'http://www.ai-china.com.cn/api', // 正式项目地址
  baseApi: 'http://www.ai-china.com.cn/api', // 正式api请求地址
  // APPID: 'xxx',
  // APPSECRET: 'xxx',
  // $cdn: 'https://www.sunniejs.cn/static'
}
